import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { useRangeValueText } from '../../hooks/use-range-value-text.js';

/**
 * A progressbar is a graphical display of the progress of a task or operation. For example,
 * showing file upload progress or loading state. A progressbar is not appropriate for values
 * that represent a measurement within a range (for example battery level), this should be
 * communicated with a meter element.
 *
 * The `children` of a `ProgressPrimitive` are always presentational and not communicated to
 * assistive technologies. They should only be used to add visual embellishments to the progressbar.
 * The contents of the progressbar should not be interactive.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/progressbar_role
 */
const ProgressPrimitive = forwardRef(({ value, min = 0, max = 1, format = 'percent', ...props }, ref) => {
    const valueText = useRangeValueText(value, max, format);
    const isIndeterminate = value === undefined;
    return (jsx("div", { "data-fpl-component": "primitive", ...props, ref: ref, role: "progressbar", "aria-valuenow": isIndeterminate ? undefined : value, "aria-valuemin": min, "aria-valuemax": max, "aria-valuetext": valueText }));
});
ProgressPrimitive.displayName = 'ProgressPrimitive';

export { ProgressPrimitive };
//# sourceMappingURL=progress-primitive.js.map
